{
  "name": "53edo (Mercator/Newton, Quintal-Tertial Notation)",
  "description": "53-tone equal tempered scale consisting of 53 sonically equal divisions per octave. Step-size is 22.6 cents (Holdrian or Mercator Comma), lying in between the Pythagorean and Syntonic Commas and therefore providing an excellent approximation of 5-Limit Rational Intonation.",
  "scale": [
    "1\\53",
    "2\\53",
    "3\\53",
    "4\\53",
    "5\\53",
    "6\\53",
    "7\\53",
    "8\\53",
    "9\\53",
    "10\\53",
    "11\\53",
    "12\\53",
    "13\\53",
    "14\\53",
    "15\\53",
    "16\\53",
    "17\\53",
    "18\\53",
    "19\\53",
    "20\\53",
    "21\\53",
    "22\\53",
    "23\\53",
    "24\\53",
    "25\\53",
    "26\\53",
    "27\\53",
    "28\\53",
    "29\\53",
    "30\\53",
    "31\\53",
    "32\\53",
    "33\\53",
    "34\\53",
    "35\\53",
    "36\\53",
    "37\\53",
    "38\\53",
    "39\\53",
    "40\\53",
    "41\\53",
    "42\\53",
    "43\\53",
    "44\\53",
    "45\\53",
    "46\\53",
    "47\\53",
    "48\\53",
    "49\\53",
    "50\\53",
    "51\\53",
    "52\\53",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "53edo",
  "built_in_group": "Equal Divisions",
  "key_labels": "note_names",
  "note_names": [
    "C",
    "C",
    "C",
    "C",
    "C",
    "C D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D E",
    "E",
    "E",
    "E",
    "E",
    "E",
    "E F",
    "E F",
    "E F",
    "F",
    "F",
    "F",
    "F",
    "F",
    "F G",
    "G",
    "G",
    "G",
    "G",
    "G",
    "G",
    "G",
    "G",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A B",
    "B",
    "B",
    "B",
    "B",
    "B",
    "B C",
    "B C",
    "B C"
  ],
  "note_colors": [
    "#ffffff",
    "#e2caca",
    "#ebc7ad",
    "#ffe5e5",
    "#d0d0d7",
    "#dee2da",
    "#f8ffeb",
    "#fceec5",
    "#fffae5",
    "#ffffff",
    "#e2caca",
    "#ebc7ad",
    "#ffe5e5",
    "#d0d0d7",
    "#dee2da",
    "#f8ffeb",
    "#fceec5",
    "#fffae5",
    "#ffffff",
    "#e2caca",
    "#e8d7b5",
    "#fffae5",
    "#ffffff",
    "#e2caca",
    "#ebc7ad",
    "#ffe5e5",
    "#d0d0d7",
    "#e1e1e0",
    "#f8ffeb",
    "#fceec5",
    "#fffae5",
    "#ffffff",
    "#e2caca",
    "#ebc7ad",
    "#ffe5e5",
    "#d0d0d7",
    "#dee2da",
    "#f8ffeb",
    "#fceec5",
    "#fffae5",
    "#ffffff",
    "#e2caca",
    "#ebc7ad",
    "#ffe5e5",
    "#d0d0d7",
    "#dee2da",
    "#f8ffeb",
    "#fceec5",
    "#fffae5",
    "#ffffff",
    "#e2caca",
    "#e8d7b5",
    "#fffae5"
  ],
  "equivSteps": 53,
  "fundamental": 440,
  "reference_degree": 40,
  "center_degree": 0,
  "rSteps": 9,
  "drSteps": 4,
  "hexSize": 40,
  "rotation": -16.102113751
}
